module.exports = __webpack_public_path__ + "static/media/Autogrow IntelliClimate Kit.86056b03.webp";